<template>
    <div class="main">

        <section  class="section1">
            <div class="container">
                <DataAtual/>
                <b-row  class="titulo">
                    Diário Oficial do Município de Belo Horizonte
                </b-row>
                <b-row class="subtitulo">
                    Busque por decretos, portarias e outras matérias.
                </b-row>

                <b-row class="busca" align-h="center">
                    <b-col class="col-sm-12 col-md-7">
                        <b-input-group >
                            <b-form-input
                                v-model="palavraChave"
                                placeholder="Digite aqui o termo que deseja pesquisar"
                                aria-describedby="feedback_busca_palavra_chave"
                                @keydown.native="keydownBuscaPalavraChave"
                                @keypress.native="keypressBuscaPalavraChave"
                                :state="palavraChaveState"
                            >
                            </b-form-input>
                            <b-input-group-append>
                                <b-button
                                    v-if="!buscaAvancada"
                                    @click="pesquisar()"
                                    variant="primary"
                                    v-b-hover="btnBuscarHover"
                                    class="btn-buscar fa fa-search ">
                                    <a class="label">{{this.labelBtnBuscar}}</a>
                                </b-button>
                                <b-button
                                    @click="buscaAvancada = !buscaAvancada"
                                    variant="outline-primary"
                                    v-b-hover="btnBuscaAvancadaHover"
                                    class="btn-busca-avancada fa fa-search-plus ">
                                    <a class="label">{{labelBtnBuscaAvancada}}</a>
                                </b-button>
                            </b-input-group-append>

                            <b-form-invalid-feedback id="feedback_busca_palavra_chave">
                                Informe o termo para pesquisa
                            </b-form-invalid-feedback>
                        </b-input-group>

                        <b-row>
                            <b-col class="card-busca-avancada" >
                                <BuscaAvancada
                                    v-show="buscaAvancada"
                                    :params="paramsBuscaAvancada"
                                    @pesquisar="pesquisar()"
                                    @fechar="buscaAvancada = false">
                                </BuscaAvancada>
                            </b-col>
                        </b-row>
                    </b-col>
                </b-row>
            </div>
        </section >

        <section  class="section2">
             <b-container>
                <b-row >
                    <b-col class="text-md-right text-center col-12 col-md-6">
                        <label class="label-calendario">
                            Selecione a data desejada:
                        </label>
                    </b-col>

                    <b-col class="text-md-left text-center col-12 col-md-3">
                        <b-form-input
                            id="input-calendario"
                            class="calendario border-secondary font-weight-bold"
                            @change="chooseDate();"
                            v-model="dataCalendario"
                            :max="maxDate"
                            type="date">
                        </b-form-input>
                    </b-col>
                </b-row>
                <hr/>
            </b-container>
        </section >

        <section  class="section3">
            <b-container>
                <b-row v-if="edicaoSelecionada.numero_edicao != null">
                    <b-col md="auto" sm="12" class="text-center">
                        <b-row>
                            <b-col >
                                <div class="label-edicao">
                                   Edição {{edicaoSelecionada.numero_edicao}} - {{edicaoSelecionada.descricao_tipo_edicao}} - Ano {{edicaoSelecionada.ano_romanos_edicao}}
                                </div>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <div v-if="edicaoPossuiDocumentoJornal(edicaoSelecionada)">
                                    <div v-if="edicaoSelecionada.documento_jornal.size > this.$constantes.documentos.TAMANHO_LIMITE_PARA_VISUALIZACAO">
                                        <b-img
                                            id="id-capa-edicao"
                                            width="264"
                                            height="340"
                                            :src="edicaoSelecionada.img_capa_src"
                                            @load="loaded()"
                                            class="border mt-2">
                                        </b-img>
                                        <b-tooltip target="id-capa-edicao">Edição disponível apenas para download</b-tooltip>
                                    </div>
                                    <div v-else>
                                        <b-link
                                            :href="obterHrefEdicao(edicaoSelecionada)"
                                            @click="clickImagemEdicao(edicaoSelecionada)">
                                            <b-img
                                                id="id-capa-edicao"
                                                width="264"
                                                height="340"
                                                :src="edicaoSelecionada.img_capa_src"
                                                @load="loaded()"
                                                class="border mt-2">
                                            </b-img>
                                        </b-link>
                                        <b-tooltip target="id-capa-edicao">Visualizar pdf da {{ edicaoSelecionada.descricao_tipo_edicao }}</b-tooltip>
                                    </div>
                                </div>
                                <div v-else>
                                    <b-img
                                        id="id-capa-edicao"
                                        width="264"
                                        height="340"
                                        :src="edicaoSelecionada.img_capa_src"
                                        @load="loaded()"
                                        class="border mt-2">
                                    </b-img>
                                </div>
                            </b-col>
                        </b-row>
                        <b-row v-if="edicaoPossuiDocumentoJornal(edicaoSelecionada)" class="mt-2">
                            <b-col >
                                <b-link
                                    class="download-edicao"
                                    @click="downloadEdicao(edicaoSelecionada)">
                                    <i class="fa fa fa-download fa-lg"></i>  Download da {{edicaoSelecionada.descricao_tipo_edicao}}
                                </b-link>
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col class="coluna2">
                        <b-row align-h="center" >
                            <b-col class="text-center my-1"
                                sm="auto"
                                v-for="edicao in listaEdicao" :key="edicao.id">
                                <b-button pill
                                    size="sm"
                                    variant="outline-primary"
                                    :pressed="edicao.id === edicaoSelecionada.id"
                                    @click="selecionarTipoEdicao(edicao)"
                                >
                                    <i class="fa fa-newspaper-o pr-1" ></i> {{ edicao.descricao_tipo_edicao }}
                                </b-button>
                            </b-col>
                        </b-row>

                        <b-row class="mt-3" v-if="showSumary">
                            <b-col class="mt-2"></b-col>
                            <b-col md="7" sm="12" >
                                <b-input-group  size="sm">
                                    <b-form-input
                                        id="filtro-sumario"
                                        v-model="filtroSumario"
                                        placeholder="Informe a sigla ou nome do órgão para filtrar o sumário"
                                        @change="filtrarSumario()"
                                    >
                                    </b-form-input>

                                    <b-input-group-append>
                                        <b-button
                                            variant="primary"
                                            @click="filtrarSumario()"
                                            class="fa fa-filter" >
                                        </b-button>
                                    </b-input-group-append>
                                </b-input-group>
                            </b-col>
                        </b-row>

                        <b-row class="mt-2" v-if="showSumary">
                            <b-col class="text-center">
                                <tree-view
                                    v-if="sumarioFiltrado && sumarioFiltrado.length"
                                    :data="sumarioFiltrado"
                                    nameFieldLabel="descricao"
                                    nameFieldChildrens="filhos"
                                    :showLineOnLeaf="false"
                                >
                                </tree-view>
                                <b-row v-else class="msg-nao-encontrado">
                                    <p>Nenhum órgão encontrado.</p>
                                </b-row>
                            </b-col>
                        </b-row>

                    </b-col>
                </b-row>
                <b-row v-else class="msg-nao-encontrado">
                    <p>Nenhuma edição encontrada para a data selecionada.</p>
                </b-row>
            </b-container>
        </section>
    </div >
</template>

<script>

import DataAtual from '../../components/DataAtual';
import BuscaAvancada from '../../components/BuscaAvancada';
import moment from 'moment';
import router from '../../routes';
import Edicao from '../../models/Edicao'
import TreeView from '../../components/TreeView/TreeView';
import { validationMixin } from "vuelidate";
import { requiredIf } from "vuelidate/lib/validators";

export default {
    components: {
        BuscaAvancada,
        TreeView,
        DataAtual
    },

    mixins: [validationMixin],

    data(){
        return {
            listaEdicao:[],
            edicaoSelecionada: new Edicao(),
            contLoaded: 0,
            palavraChave: '',
            palavraChaveState: null,
            paramsBuscaAvancada: {
                tipoPesquisa: this.$constantes.pesquisa.tipoPesquisa.QUALQUER_RESULTADO,
                formaPesquisa: this.$constantes.pesquisa.formaPesquisa.EDICOES,
                ondePesquisar: this.$constantes.pesquisa.ondePesquisar.CONTEUDO,
                dataInicio: null,
                dataFim: null,
                numeroEdicao: null,
                categoriaAtoId: null,
                orgaoId: null,
                orgao:null,
            },
            buscaAvancada: false,
            dataCalendario: '',
            codigoAutenticidade: '',
            sumarioCompleto: [],
            sumarioFiltrado: [],
            filtroSumario:'',
            showSumary: false,
            maxDate: moment().format('YYYY-MM-DD'),
            labelBtnBuscar: '',
            labelBtnBuscaAvancada: '',
        }
    },

    validations: {
        palavraChave: {
            requiredIf: requiredIf(function () {
                return !this.buscaAvancada;
            })
        },
    },

    methods: {

        autenticidade() {
            this.$router.push({
                name: 'verificarautenticidade'
            });
        },

        loaded() {
            this.contLoaded++;
            if( this.contLoaded >= 2 ) {
                router.app.carregando = false;
            }
        },

        btnBuscarHover(hovered){
            this.labelBtnBuscar = '';
            if(hovered){
                this.labelBtnBuscar = 'Buscar';
            }
        },

        btnBuscaAvancadaHover(hovered){
            this.labelBtnBuscaAvancada = '';
            if(hovered || this.buscaAvancada){
                this.labelBtnBuscaAvancada = 'Busca Avançada';
            }
        },

        edicaoPossuiDocumentoJornal(edicao){
            return edicao.documento_jornal && edicao.documento_jornal.nome_minio;
        },

        clickImagemEdicao(edicao){
            if(this.$helper.isMobile()) {
                let url = `${this.$env.VUE_APP_URL_API}/api/v1/documentos/${edicao.documento_jornal.nome_minio}`;
                if(edicao.documento_jornal.prefix){
                    url += `?prefix=${edicao.documento_jornal.prefix}`;
                }
                window.open(url);
            }
        },

        obterHrefEdicao(edicao){
            return this.$helper.isMobile() ? null : `visualizacao/edicao/${edicao.id}`;
        },

        downloadEdicao(edicao) {
            let url = `${this.$env.VUE_APP_URL_API}/api/v1/documentos/${edicao.documento_jornal.nome_minio}/download`;
            if(edicao.documento_jornal.prefix){
                url += `?prefix=${edicao.documento_jornal.prefix}`;
            }
            window.location.assign(url);
        },

        async chooseDate() {
            var reg = /(\d{4})-(\d{2})-(\d{2})/;
            if( reg.test(this.dataCalendario) ){
                await this.buscarPublicacaoPorData(this.dataCalendario);

                if(this.listaEdicao.length > 0){
                    this.setEdicaoSelecionada(this.listaEdicao[0]); //Atualiza os dados da edicaoSelecionada com o primeiro tipo de edicao
                    this.listarSumario(this.edicaoSelecionada.id);
                }

                let params = {
                    dataCalendario: this.dataCalendario,
                    edicaoSelecionada: this.edicaoSelecionada
                }

                sessionStorage.setItem('home', JSON.stringify(params));
            }
        },

        setEdicaoSelecionada(edicao){
            this.edicaoSelecionada = edicao;

            if(this.edicaoSelecionada.documento_capa && this.edicaoSelecionada.documento_capa.nome_minio){
                router.app.carregando = true;
                this.edicaoSelecionada.img_capa_src = `${this.$env.VUE_APP_URL_API}/api/v1/documentos/${edicao.documento_capa.nome_minio}`;
                if(edicao.documento_capa.prefix){
                  this.edicaoSelecionada.img_capa_src += `?prefix=${edicao.documento_capa.prefix}`;
                }
            }else{
                this.edicaoSelecionada.img_capa_src = './imgs/capa_dom.png';
            }

        },

        limparEdicaoSelecionada(){
            this.edicaoSelecionada = new Edicao();
            this.edicaoSelecionada.img_capa_src = './imgs/capa_dom.png';
            this.edicaoSelecionada.descricao_tipo_edicao = '';
        },

        buscarUltimaEdicaoPublicada() {
            return this.$api.edicao.ultimaPublicacao().then(response => {
                if(response.status == 200 || response.status == 201){
                    this.listaEdicao = [];

                    if(response.data.data.length === 0){
                        this.limparEdicaoSelecionada();
                        this.showSumary = false;
                    }
                    else{
                        response.data.data.forEach((item) => {
                            let edicao = new Edicao(item);
                            edicao.descricao_tipo_edicao = this.$helper.getTipoEdicao(edicao.tipo_edicao);
                            edicao.ordem_tipo_edicao = this.$helper.getOrdemTipoEdicao(edicao.tipo_edicao);
                            edicao.numero_tipo_edicao = edicao.numero_edicao +' - '+ edicao.descricao_tipo_edicao;
                            this.listaEdicao.push(edicao);

                            this.dataCalendario = edicao.dt_publicacao;
                        });

                        //Ordena pelo tipo da edicao
                        this.listaEdicao.sort((a, b) => {
                           return a.ordem_tipo_edicao < b.ordem_tipo_edicao ? -1 : a.ordem_tipo_edicao > b.ordem_tipo_edicao ? 1 : 0;
                        });
                    }
                }
            });

        },

        buscarPublicacaoPorData(data) {
            let parametro = {
               data: data
            };

            return this.$api.edicao.buscarPublicacaoPorData(parametro).then(response => {
                if(response.status == 200 || response.status == 201){
                    this.listaEdicao = [];

                    if(response.data.data.length === 0){
                        this.limparEdicaoSelecionada();
                        this.showSumary = false;
                    }
                    else{
                        response.data.data.forEach((edicao) => {
                            edicao.descricao_tipo_edicao = this.$helper.getTipoEdicao(edicao.tipo_edicao);
                            edicao.ordem_tipo_edicao = this.$helper.getOrdemTipoEdicao(edicao.tipo_edicao);
                            edicao.numero_tipo_edicao = edicao.numero_edicao +' - '+ edicao.descricao_tipo_edicao;
                            this.listaEdicao.push(edicao);
                        });

                        //Ordena pelo tipo da edicao
                        this.listaEdicao.sort((a, b) => {
                           return a.ordem_tipo_edicao < b.ordem_tipo_edicao ? -1 : a.ordem_tipo_edicao > b.ordem_tipo_edicao ? 1 : 0;
                        });
                    }
                }
            });

        },

        pesquisar(){
            if( !this.buscaAvancada && this.palavraChave.trim().length <= 0 ){
                this.palavraChaveState = false;
                return;
            }

            this.$router.push({ name: 'resultadobusca', query: {
                                                                palavraChave: this.palavraChave,
                                                                tipoPesquisa: this.paramsBuscaAvancada.tipoPesquisa,
                                                                formaPesquisa: this.paramsBuscaAvancada.formaPesquisa,
                                                                ondePesquisar: this.paramsBuscaAvancada.ondePesquisar,
                                                                dataInicio: this.paramsBuscaAvancada.dataInicio,
                                                                dataFim: this.paramsBuscaAvancada.dataFim,
                                                                numeroEdicao: this.paramsBuscaAvancada.numeroEdicao,
                                                                categoriaAtoId: this.paramsBuscaAvancada.categoriaAtoId,
                                                                orgaoId: this.paramsBuscaAvancada.orgaoId,
                                                                orgao:this.paramsBuscaAvancada.orgao,
                                                                buscaAvancada: this.buscaAvancada
                                                        }});
        },


        selecionarTipoEdicao(edicao){

            //Atualiza os dados da edicaoSelecionada com o primeiro tipo de edicao
            this.setEdicaoSelecionada(edicao);

            let params = {
                dataCalendario: this.dataCalendario,
                edicaoSelecionada: this.edicaoSelecionada
            }

            sessionStorage.setItem('home', JSON.stringify(params));


            //Lista sumario da edicao
            this.listarSumario(this.edicaoSelecionada.id);
        },

        expandirSumario(listaSumario){
            listaSumario.forEach(item => {
                if(item.hasOwnProperty('filhos') && item.filhos.length > 0 && !item.filhos.some(e => e.tipo === this.$constantes.sumario.tipo.ATO)){
                    item.showDetails = true;
                    this.expandirSumario(item.filhos);
                }else{
                    return;
                }
            });
        },

        setSumario(sumario){
            sumario.forEach(item => {
                if(item.tipo === this.$constantes.sumario.tipo.ATO){
                    item.href = `visualizacao/ato/${item.id}`;
                    item.styleContent = 'color:#515151;text-indent:-0.3rem;padding-left:0.6rem;';
                    item.icon = 'fa fa-caret-right';
                }else{
                    item.styleLink = 'text-decoration:none;';
                }

                if(!item.hasOwnProperty('filhos') || item.filhos.length === 0){
                    return;
                }else{
                   this.setSumario(item.filhos);
                }
            });
        },

        listarSumario($edicao_id){
            this.sumarioFiltrado = [];
            this.sumarioCompleto = [];
            this.$api.edicao.sumario($edicao_id)
                .then(response => {
                        this.sumarioCompleto = response.data.data;
                        this.setSumario(this.sumarioCompleto);
                        this.expandirSumario(this.sumarioCompleto);
                        this.showSumary = this.sumarioCompleto.length > 0;
                        this.sumarioFiltrado = this.sumarioCompleto;
                });
        },

        filtrarSumario() {
            const getNodes = (result, object) => {
                if (object.descricao.match(new RegExp(this.filtroSumario, "i")) && object.tipo === this.$constantes.sumario.tipo.ORGAO) {
                    result.push(object);
                    return result;
                }

                if (Array.isArray(object.filhos)) {
                   const nodes = object.filhos.reduce(getNodes, []);

                   if(nodes.length){
                       result = nodes;
                   }
                }

                return result;
            };

            this.sumarioFiltrado = this.sumarioCompleto.reduce(getNodes, []);
        },

        keydownBuscaPalavraChave(event){
            if (event.which === 13) {// 13 = Tecla Enter
                this.pesquisar();
            }
        },


        keypressBuscaPalavraChave(){
            if(this.palavraChave.trim().length > 0) {
                this.palavraChaveState = null;
            }
        },

    },

    async mounted(){
        let edicao = null;
        let params = sessionStorage.getItem('home') ? JSON.parse(sessionStorage.getItem('home')) : null;

        //Verifica se
        if(params){
            edicao = params.edicaoSelecionada;
            this.dataCalendario = params.dataCalendario;
            await this.buscarPublicacaoPorData(this.dataCalendario);
        }else{
            await this.buscarUltimaEdicaoPublicada();
            edicao = this.listaEdicao[0]; //Atualiza os dados da edicaoSelecionada com o primeiro tipo de edicao
        }

        if(this.listaEdicao.length > 0){
            this.setEdicaoSelecionada(edicao);
            this.listarSumario(this.edicaoSelecionada.id);
        }
    },
}
</script>

<style scoped>

    .main{
        background-color: #FFFFFF;
    }

    .section1{
        padding-bottom: 0.8em;
        background-color: #FAFAFA;
    }

    .section1 .titulo{
        font-size: 1.8rem;
        font-weight: bold;
        text-align: center;
        justify-content: center;
        margin-top: 0.35em;
    }
    .section1 .subtitulo{
        font-size: 0.9em;
        font-weight: lighter;
        color: gray;
        padding-bottom: 1.5em;
        text-align: center;
        justify-content: center;
    }

    .section1 .card-busca-avancada {
        padding-top: 0.15em;
        position: absolute;
        z-index: 1051;
    }

    .section2 {
        padding-top: 0.7em;
        padding-bottom: 0.7rem;
    }

    .section2 .label-calendario {
        color: #5F6368;
        font-size: 0.9em;
        font-weight: bold;
    }

    .section2 .calendario {
        max-width: 275px;
        text-align: center;
        margin: auto;
    }

    .section3 {
        min-height: calc(100vh - 375px);
        padding-bottom: 1.5rem;
    }

    .section3  .label-edicao {
        color: #337ab7;
        font-weight: bold;
        font-size: 0.90em;
    }

    .section3 .download-edicao {
        color: #5F6368;
        font-size: 0.87em;
    }

    .section3 .msg-nao-encontrado {
        color: grey;
        font-size: 0.85em;
        text-align: center;
        justify-content: center;
    }

    .section2, .section3 {
        background-color: #FFFFFF;
    }

    @media (max-width: 767.98px) {
        .section3  .coluna2{
            padding-top: 1.5em;
        }
    }

</style>